export default {
	login (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'auth/branch_office/login', params)
	},
	logout (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'auth/branch_office/logout', params)
	},
	check (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'auth/branch_office/check', params)
	}
}



// WEBPACK FOOTER //
// ./src/api/BranchOfficeAuth.js